import { AxiosInstance } from 'axios';
import http from '@/views/student/http';

function getStateCtor(http: AxiosInstance) {
  return async (projectId: string, sessionId: string) => {
    const { data } = await http.get(`/checkout/${projectId}/${sessionId}/archive-credit-check`);
    return data;
  };
}

export default getStateCtor(http);
